import React from 'react';
import { Grid, Typography, Card } from '@material-ui/core';
import { styled } from '@mui/styles';
import { RunningCampaignResponse } from '../../jsonutils/dashboard';
import { dashboardHeights } from './DashboardParent';
const PREFIX = 'CampaignDetails';

const classes = {
    title: `${PREFIX}-title`,
    GridItems: `${PREFIX}-GridItems`,
    card: `${PREFIX}-card`,
    grid: `${PREFIX}-grid`,
    TotalTxt: `${PREFIX}-TotalTxt`,
    Txt: `${PREFIX}-Txt`,
    item: `${PREFIX}-item`,
    AdvText: `${PREFIX}-AdvText`,
    campaignGridItem: `${PREFIX}-campaignGridItem`
};

const Root = styled('div')((
    {
        theme
    }
) => ({
    [`& .${classes.title}`]: {
		color: '#ffffff',
		backgroundColor: '#085DAD',
		padding: theme.spacing(1),
		fontWeight: 600,
		fontFamily: 'Calibri',
	},

    [`& .${classes.GridItems}`]: {
		backgroundColor: '#ffffff',
		borderRadius: theme.spacing(0.25),
	},

    [`& .${classes.card}`]: {
		borderRadius: '0px',
	},

    [`& .${classes.grid}`]: {
		height: 'calc(100% -  40px)',
	},

    [`& .${classes.TotalTxt}`]: {
		color: '#669900',
		fontWeight: 600,
	},

    [`& .${classes.Txt}`]: {
		color: '#234143',
		fontWeight: 600,
		fontFamily: 'Calibri',
	},

    [`& .${classes.item}`]: {
		backgroundColor: '#ffffff',
		flexBasis: '30%',
	},

    [`& .${classes.AdvText}`]: {
		color: '#4c76a2',
		fontWeight: 600,
		fontFamily: 'Calibri',
	},

    [`& .${classes.campaignGridItem}`]: (props: any) => ({
		[theme.breakpoints.down('sm')]: {
			height: props.smDown,
		},
		[theme.breakpoints.down('md')]: {
			height: props.mdDown,
		},
		[theme.breakpoints.down('lg')]: {
			height: props.lgDown,
		},
		[theme.breakpoints.down('xl')]: {
			height: props.xlDown,
		},
		[theme.breakpoints.up('xl')]: {
			height: props.xlUp,
		},
	})
}));

export interface Props {
	data: RunningCampaignResponse;
}

function CampaignDetails(props: Props) {

	const data = props.data;
	return (
        (<Root>
            <Card elevation={4} className={classes.campaignGridItem}>
				<Typography variant="h3" align="center" className={classes.title}>
					Campaign Details
				</Typography>

				<Grid container direction="row" justify="space-between" alignItems="center" className={classes.grid}>
					<Grid item xs={3} className={classes.GridItems}>
						<Typography variant="h5" align="center" className={classes.Txt}>
							{' '}
							Current Campaigns
						</Typography>
						<Typography
							align="center"
							variant="h1"
							className={classes.AdvText}>
							{data.campaignCount}
						</Typography>
					</Grid>
					<Grid item xs={3} className={classes.item}>
						<Typography variant="h5" align="center" className={classes.Txt}>
							Main Locations
						</Typography>
						<Typography
							align="center"
							variant="h1"
							className={classes.AdvText}>
							{data.mainLocationCount}
						</Typography>
					</Grid>
					<Grid item xs={3} className={classes.GridItems}>
						<Typography variant="h5" align="center" className={classes.Txt}>
							Devices
						</Typography>
						<Typography
							align="center"
							variant="h1"
							className={classes.AdvText}>
							{data.deviceCount}
						</Typography>
					</Grid>
					<Grid item xs={3} className={classes.GridItems}>
						<Typography variant="h5" align="center" className={classes.Txt}>
							Viewership
						</Typography>
						<Typography
							align="center"
							variant="h1"
							className={classes.AdvText}>
							{data.viewershipCount}
						</Typography>
					</Grid>
				</Grid>
			</Card>
        </Root>)
    );
}

export default CampaignDetails;
